import React from 'react'
import { OverlayTrigger, Popover } from 'react-bootstrap'
import Icon from 'UI/FontAwesomeIcon'

const DateCell = ({ datetime }) => {
  if (!datetime) return 'Undefined'

  const [date, time] = datetime.replace('Z', '').split('T')

  return (
    <>
      <div>{date}</div>
      <div>{time}</div>
    </>
  )
}

const StatusCell = ({ status, errorMessage }) => (
  <div className="flex">
    {status}

    {errorMessage && (
      <OverlayTrigger trigger="hover" placement="right" overlay={<Popover id="popover-basic">
      <Popover.Header as="h3">Error Message</Popover.Header>
      <Popover.Body>
        {errorMessage.split("<br>").map(error => <div>{error}</div>)}
      </Popover.Body>
    </Popover>}>
        <div className="ml-2 text-red-500 duration-300 cursor-pointer hover:text-red-700">
          <Icon icon="exclamation-circle" />
        </div>
      </OverlayTrigger>
    )}
  </div>
)

const customerColumn = {
  width: 200,
  Header: 'Customer',
  accessor: 'customerName'
}

const storagePolicyColumn = {
  width: 250,
  Header: 'Storage Policy',
  accessor: 'storagePolicyName'
}

const commcellColumn = {
  width: 200,
  Header: 'Commcell',
  accessor: 'commcellName'
}

const locationColumn = {
  width: 200,
  Header: 'Location',
  accessor: 'locationName'
}

const jobTypeColumn = {
  Header: 'Job Type',
  accessor: 'jobType'
}

const subclientColumn = {
  width: 250,
  Header: 'Subclient',
  accessor: 'subclient'
}

const frequencyColumn = {
  Header: 'Frequency',
  accessor: 'frequency'
}

const commvaultJobIdColumn = {
  Header: 'Commvault Job ID',
  accessor: 'commvaultJobId'
}

const backupLevelColumn = {
  Header: 'Backup Level',
  accessor: 'backupLevel'
}

const latestJobStatusColumn = {
  Header: 'Latest Job Status',
  accessor: 'latestJobStatus',
  Cell: ({ original: { errorMessage, latestJobStatus } }) => (
    <StatusCell status={latestJobStatus} errorMessage={errorMessage} />
  )
}

const latestJobStartTimeColumn = {
  Header: 'Latest Job Start Time',
  accessor: 'latestJobStartTime',
  Cell: ({ value }) => <DateCell datetime={value} />
}

const latestJobEndTimeColumn = {
  Header: 'Latest Job End Time',
  accessor: 'latestJobEndTime',
  Cell: ({ value }) => <DateCell datetime={value} />
}

const lastCompletedJobTimeColumn = {
  Header: 'Last Completed Job Time',
  accessor: 'lastCompletedJobTime',
  Cell: ({ value }) => <DateCell datetime={value} />
}

export const Columns = [
  customerColumn,
  storagePolicyColumn,
  commcellColumn,
  locationColumn,
  jobTypeColumn,
  subclientColumn,
  frequencyColumn,
  commvaultJobIdColumn,
  backupLevelColumn,
  latestJobStatusColumn,
  latestJobStartTimeColumn,
  latestJobEndTimeColumn,
  lastCompletedJobTimeColumn
]
